import { FormProvider, useForm, type FieldErrors } from 'react-hook-form'

import { initialFormValues } from './form/initialFormValues'
import { CloseIcon } from '@assets/svgs/CloseIcon'
import { FilterIcon } from '@assets/svgs/FilterIcon'
import { Button } from '@components/shared/Button'
import { RowBox } from '@components/shared/RowBox'
import { Select } from '@components/shared/Select'

import type { AdditionalExpensesFiltersFormProps } from './form/types'
import type { AdditionalExpensesFiltersProps } from './types'

import * as S from './styles'

export const AdditionalExpensesFilters = ({ isLoading, data, onFilter }: AdditionalExpensesFiltersProps) => {
  const methods = useForm<AdditionalExpensesFiltersFormProps>({
    defaultValues: initialFormValues
  })

  const onError = (errors: FieldErrors<AdditionalExpensesFiltersFormProps>) => console.log({ errors })

  const onSubmit = (formData: AdditionalExpensesFiltersFormProps) => onFilter(formData)

  return (
    <FormProvider {...methods}>
      <RowBox columns={5} marginTop={16} marginBottom={24}>
        <Select
          name="account"
          label="Conta"
          options={
            !!data?.expenseTypes?.length
              ? data?.expenseTypes.map((option) => ({
                  label: option.accountingCode,
                  value: option.accountingCode
                }))
              : []
          }
          disabled={isLoading}
        />
        <Select
          name="accountDescription"
          label="Descrição Conta"
          options={
            !!data?.expenseTypes?.length
              ? data?.expenseTypes.map((option) => ({
                  label: option.description,
                  value: option.description
                }))
              : []
          }
          disabled={isLoading}
        />

        <S.FilterButtons>
          <Button
            width="100%"
            colorType="outlineBlue"
            rightIcon={<FilterIcon />}
            onClick={() => methods.handleSubmit(onSubmit, onError)()}
            disabled={isLoading}
          >
            Filtrar
          </Button>

          <Button
            width="100%"
            colorType="outlineBlue"
            rightIcon={<CloseIcon />}
            onClick={() => {
              methods.reset()
              onFilter(initialFormValues)
            }}
            disabled={isLoading}
          >
            Limpar
          </Button>
        </S.FilterButtons>
      </RowBox>
    </FormProvider>
  )
}
